import { Link } from "react-router-dom";
import { ArrowUpRight } from "lucide-react";
import { Container, SectionHeading } from "@/components/common/ui";
import { GUIDES } from "@/lib/guides";

/** Homepage "Find your path" row: the 7 guides (first one is wide so the grid fills evenly). */
export const GuideTiles = () => (
  <section className="py-16 sm:py-20" data-testid="home-guides">
    <Container>
      <SectionHeading eyebrow="Find your path" title="Everything you need, in one place" subtitle="Pick where you are and we'll take it from there." />
      <div className="mt-10 grid gap-4 sm:grid-cols-2 lg:grid-cols-4">
        {GUIDES.map((g, i) => (
          <Link key={g.slug} to={`/guides/${g.slug}`} data-testid={`guide-tile-${g.slug}`}
            className={`group relative flex h-64 overflow-hidden rounded-md bg-ink ${i === 0 ? "sm:col-span-2" : ""}`}>
            <img src={g.img} alt="" loading="lazy" className="absolute inset-0 h-full w-full object-cover opacity-80 transition-transform duration-700 group-hover:scale-105" />
            <div className="absolute inset-0 bg-gradient-to-t from-black/85 via-black/35 to-black/10" />
            <div className="relative mt-auto p-5 text-white">
              <p className="text-xl font-medium leading-snug">{g.nav}</p>
              <p className="mt-1 text-[14px] text-white/85">{g.tile}</p>
            </div>
            <ArrowUpRight className="absolute right-4 top-4 h-5 w-5 text-white transition-transform group-hover:-translate-y-0.5 group-hover:translate-x-0.5" />
          </Link>
        ))}
      </div>
    </Container>
  </section>
);
